import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Breadcrumb, Typography, Spin, Select } from 'antd';
import { formItemLayout, tailFormItemLayout, unexpectedError, handleBackendFormErrors, backButton } from '../../../common_functions';
import RestrictedPage from '../../../../error/restrictedPage';
const Locations = props => {
  const { section, id } = useParams();
  const [location, setLocation] = useState({});
  const [loading, setLoading] = useState(false);
  const [collections, setCollections] = useState([]);
  const [restricted, setRestricted] = useState(false);
  const formRef = useRef(null);
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        // get collection list
        let { data: collectionData } = await props.getItems('collections', {
          fields: ['id', 'name'],
          sort: 'name',
          limit: -1,
        });
        setCollections(collectionData);
        if (id !== 'new') {
          let { data } = await props.getItem('location', id);
          if (props.roleType !== 'admin' && !props.collections_permissions.view.includes(data.collections)) {
            setRestricted(true);
            return;
          }
          setLocation(data);
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [section, id]);
  const setLocationName = () => {
    const formFields = formRef.current.getFieldsValue();
    const name = [formFields.site, formFields.room, formFields.shelf, formFields.box].filter(Boolean).join('-');
    formRef.current.setFieldsValue({ name });
  };
  let onFinish = async values => {
    try {
      setLoading(true);
      let newState = { ...location, ...values };
      await props.saveItem('location', newState);
      notification.success({
        message: 'Location saved successfully!',
        duration: 2,
      });
      backButton(props, `/settings/object-locations`);
    } catch (errorResponse) {
      handleBackendFormErrors(formRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  return (
    <>
      {restricted ? (
        <RestrictedPage />
      ) : (
        <Spin spinning={loading} size="large">
          <Row>
            <Col className="app-breadcrumb-col">
              <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/object-locations" }, { title: "Object Locations", href: "/settings/object-locations" }, { title: id != 'new' ? `Edit Object Location` : 'Add Object Location' }]} />
            </Col>
            <Col className="white-paper">
              <Row gutter={24} className="page-header-section" align="middle">
                <Col xs={12}>
                  <Typography.Title level={4} style={{ margin: 0 }}>
                    {id != 'new' ? `Edit Object Location: ${id}` : 'Add Location'}
                  </Typography.Title>
                </Col>
                <Col xs={12} justify="end"></Col>
              </Row>
              <hr />
              <div className="artist">
                <Form
                  ref={formRef}
                  layout="vertical"
                  {...formItemLayout}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{ layout: tailFormItemLayout }}
                >
                  <Row gutter={24}>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item
                        name="collections"
                        label="Collection"
                        rules={[
                          {
                            required: true,
                            message: 'Collection is required!',
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select collection"
                          optionFilterProp="children"
                          showSearch
                          allowClear
                          filterOption={(input, option) => option.children.includes(input)}
                          disabled={id !== 'new' ? true : false}
                        >
                          {collections.map(col => {
                            return <Select.Option key={col.id} value={col.id}>{col.name}</Select.Option>;
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item
                        name="site"
                        label="Site"
                        rules={[
                          {
                            whitespace: true,
                            required: true,
                            message: 'Site is required!',
                          },
                        ]}
                      >
                        <Input placeholder="Enter site" onKeyUpCapture={setLocationName} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="room" label="Room">
                        <Input placeholder="Enter room" onKeyUpCapture={setLocationName} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="shelf" label="Shelf">
                        <Input placeholder="Enter shelf" onKeyUpCapture={setLocationName} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="box" label="Box">
                        <Input placeholder="Enter box" onKeyUpCapture={setLocationName} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item
                        name="name"
                        label="Location Name"
                        rules={[
                          {
                            whitespace: true,
                            required: false,
                            message: 'Location name is required!',
                          },
                        ]}
                      >
                        <Input placeholder="Enter location name" readOnly />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item {...tailFormItemLayout}>
                    <Button
                      type="default"
                      htmlType="button"
                      onClick={() => {
                        backButton(props, `/settings/object-locations`);
                      }}
                      style={{
                        borderColor: '#d9d9d9',
                        background: '#f5f5f5',
                        color: 'rgba(0, 0, 0, 0.85)',
                      }}
                    >
                      Back
                    </Button>
                    {props.showButton(props.roleType, props.tabs_permissions.settings_locations, !!location ? location.id : '')}
                  </Form.Item>
                </Form>
              </div>
            </Col>
          </Row>
        </Spin>
      )}
    </>
  );
};

export default Locations;
